export enum PermissionOperator {
  Or,
  And,
}
